import React from 'react';
import { X } from 'lucide-react';

export function NoteModal({ open, onClose, note, onNoteChange }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center p-4" style={{ zIndex: 2000 }}>
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="bg-white rounded-2xl w-full max-w-md relative">
        <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-900">Nota</h2>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-100">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6 space-y-4">
          <p className="text-sm text-gray-600">Ingrese una nota sobre la entrega</p>
          <textarea
            value={note}
            onChange={(e) => onNoteChange(e.target.value)}
            placeholder="Ej: Cliente no estaba, se dejó con portero"
            className="w-full h-32 px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-brand-primary focus:outline-none resize-none"
          />
          <button
            onClick={onClose}
            className="w-full bg-brand-primary text-white py-3 rounded-lg font-semibold hover:bg-brand-primary/90"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  );
}